import { render, staticRenderFns } from "./CreateUpdatePage.vue?vue&type=template&id=3fe6b952&scoped=true"
import script from "./CreateUpdatePage.vue?vue&type=script&lang=js"
export * from "./CreateUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdatePage.vue?vue&type=style&index=0&id=3fe6b952&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe6b952",
  null
  
)

export default component.exports